import React, { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { PostForm } from './PostForm'
import AppLayout from '../common/AppLayout'
import AppTitle from '../common/AppTitle'

export const PostsAddPage = () => {
    const {t} = useTranslation()

    useEffect(() => {

    }, [])

    return (
        <AppLayout>
            <AppTitle append={<Link to={'/app/posts'}>
                <button className="btn amani-primary">{t('back')}</button>
            </Link>}>{t('new_post')}</AppTitle>
            <PostForm/>
        </AppLayout>
    )
}
